/*
 * Moonless quick add.
 *
 * Tapping a size IS the add. No second button, no modal, no page load. The pill sets the hidden
 * variant input and submits immediately; everything after that (the fetch, the cart drawer
 * render, error handling) is the theme's own product-form.js, which this markup plugs into.
 *
 * Delegated from the document so cards injected later, by a cart drawer re-render or a
 * recommendations fetch, keep working without re-binding.
 */
(function () {
	'use strict';

	var BUSY = 'is-adding';
	var DONE = 'is-added';

	function formOf(pill) {
		return pill.closest('form');
	}

	function readVariants(form) {
		var el = form.querySelector('[data-ml-variants]');
		if (!el) return null;
		try { return JSON.parse(el.textContent); } catch (e) { return null; }
	}

	/* The colour the shopper picked is whichever swatch radio is checked in this card. The
	   swatches sit on the photo, outside the form, so look them up from the card wrapper. */
	function pickedColor(form) {
		var card = form.closest('.js-color-swatches-wrapper') || form.closest('.product-card');
		if (!card) return null;
		var checked = card.querySelector('.js-color-swatches input[type="radio"]:checked');
		return checked ? checked.value : null;
	}

	/* Resolve the variant to add from BOTH the picked colour and the tapped size. Colour values
	   and size values come from different option lists, so an exact string match on each is
	   enough without knowing which option slot is which. Falls back to the pill's own id when
	   the product has no colour to pick. */
	function resolveVariantId(form, pill) {
		var size = pill.getAttribute('data-size-value');
		var color = pickedColor(form);
		var variants = readVariants(form);

		if (color && size && variants) {
			var firstMatch = null;
			for (var i = 0; i < variants.length; i++) {
				var opts = variants[i].options || [];
				if (opts.indexOf(color) !== -1 && opts.indexOf(size) !== -1) {
					if (variants[i].available) return String(variants[i].id);
					if (!firstMatch) firstMatch = String(variants[i].id);
				}
			}
			if (firstMatch) return firstMatch;
		}

		return pill.getAttribute('data-variant-id');
	}

	function selectSize(pill) {
		var form = formOf(pill);
		if (!form) return null;

		var input = form.querySelector('[data-ml-variant-input]');
		var variantId = resolveVariantId(form, pill);
		if (!input || !variantId || variantId === '0') return null;

		form.querySelectorAll('[data-ml-size]').forEach(function (other) {
			other.classList.remove(DONE);
		});

		input.value = variantId;
		return form;
	}

	/* Only hint at the scroll when there is actually something off-screen. A fade on a row
	   that already fits just looks like a rendering bug. */
	function markScrollable(root) {
		(root || document).querySelectorAll('[data-ml-sizes-wrap]').forEach(function (wrap) {
			var row = wrap.querySelector('.ml-bar__sizes');
			if (!row) return;
			wrap.classList.toggle('is-scrollable', row.scrollWidth - row.clientWidth > 4);
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		markScrollable();
	});
	window.addEventListener('resize', function () {
		markScrollable();
	});
	document.addEventListener(
		'scroll',
		function (event) {
			var row = event.target;
			if (row && row.classList && row.classList.contains('ml-bar__sizes')) {
				var wrap = row.closest('[data-ml-sizes-wrap]');
				if (wrap) {
					wrap.classList.toggle(
						'is-scrollable',
						row.scrollWidth - row.clientWidth - row.scrollLeft > 4
					);
				}
			}
		},
		true
	);

	document.addEventListener('click', function (event) {
		var pill = event.target.closest('[data-ml-size]');
		if (!pill || pill.disabled) return;

		event.preventDefault();

		/* Ignore a second tap while the first is still in flight, otherwise an impatient
		   double-tap quietly adds two of the same size. */
		if (pill.classList.contains(BUSY)) return;

		var form = selectSize(pill);
		if (!form) return;

		pill.classList.add(BUSY);

		/* requestSubmit fires a real submit event, which is what product-form.js listens for.
		   form.submit() would bypass the listener and do a full page navigation. */
		if (typeof form.requestSubmit === 'function') {
			form.requestSubmit();
		} else {
			form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
		}

		/* product-form.js gives no completion callback, so confirm off the cart update event
		   it publishes, and fall back to a timeout so a pill can never stay stuck spinning. */
		var settle = function () {
			pill.classList.remove(BUSY);
			if (pill.dataset.settled) return;
			pill.dataset.settled = '1';
			/* Flash "added" briefly, then clear it, otherwise the pill reads as a permanent
			   selection ("still purple when I come back") even though the size is not sticky. */
			pill.classList.add(DONE);
			setTimeout(function () { pill.classList.remove(DONE); delete pill.dataset.settled; }, 1300);
		};

		if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
			var off = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
				settle();
				if (typeof off === 'function') off();
			});
		}
		setTimeout(settle, 2500);
	});
})();
